._categoryViewWrapper_1a20e_1 {
  background: #fff;
  box-sizing: border-box;
  display: inline-block;
  height: 100%;
  overflow: hidden;
  white-space: normal;
  flex-shrink: 0; }

._categoryView_1a20e_1 {
  height: 100%; }

._categoryView_1a20e_1 .custom-scroll .inner-container.content-scrolled:after {
  content: none; }

._sections_1a20e_16 {
  display: flex;
  flex-direction: column;
  align-items: center; }

._section_1a20e_16 {
  flex: 0 0 auto; }

._panelHeader_1a20e_24 {
  height: 46px;
  min-height: 0; }

._panelHeader_1a20e_24 .control-label-base {
  color: #2b5672 !important; }
